import { useDispatch } from 'react-redux'

import {
  searchMapsByWorkspaceIdQuery,
  useMaps,
  useMapsLoading,
  useMapsTotal
} from '~workspace/states/maps'

const useSearchMapsByWorkspaceIdQuery = () => {
  const dispatch = useDispatch()
  const maps = useMaps()
  const total = useMapsTotal()
  const loading = useMapsLoading()

  const refetch = ({ workspaceId, limit, offset, query, tagIds }) => {
    dispatch(
      searchMapsByWorkspaceIdQuery({
        workspaceId,
        limit,
        offset,
        query,
        tagIds
      })
    )
  }

  return { maps, total, loading, refetch }
}

export { useSearchMapsByWorkspaceIdQuery }
export default useSearchMapsByWorkspaceIdQuery
